// src/components/LatestValidations.jsx
//
// Manager Dashboard: the last 10 validations - when, where (the facility,
// backend routes/getAllValidation.ts joins its name), the rating and status.
import React from 'react';
import { Paper, Typography, Box } from '@mui/material';

const formatDate = (d) => {
  const date = new Date(d);
  return Number.isNaN(date.getTime())
    ? '—'
    : new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(date);
};

export default function LatestValidations({ validations, count = 10 }) {
  const latest = [...(validations || [])]
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .slice(0, count);

  return (
    <Paper elevation={3} sx={{ p:3, mb:4 }}>
      <Typography variant="h6" gutterBottom>Last {count} validations</Typography>
      {latest.length === 0 ? (
        <Typography color="text.secondary">No validation yet.</Typography>
      ) : (
        <Box sx={{ overflowX:'auto' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead>
              <tr style={{ background:'#f5f5f5' }}>
                {['Date', 'Facility', 'Rating', 'Status'].map(h => (
                  <th key={h} style={{ padding:8, textAlign:'left' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {latest.map(v => {
                const id = v.facilityId ?? v.storeId;
                return (
                  <tr key={v.id} style={{ borderTop:'1px solid #eee' }}>
                    <td style={{ padding:8, whiteSpace:'nowrap' }}>{formatDate(v.created_at)}</td>
                    <td style={{ padding:8 }}>
                      {v.facilityName || 'Unknown facility'}{id != null && ` (#${id})`}
                    </td>
                    <td style={{ padding:8 }}>{v.rating != null ? `${'★'.repeat(Math.round(v.rating))} ${v.rating}` : '—'}</td>
                    <td style={{ padding:8 }}>{v.validation_status || '—'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Box>
      )}
    </Paper>
  );
}
